module.exports = __webpack_public_path__ + "static/media/nip-group.ea8c97ff.svg";